import styled from 'styled-components';

import {
  MultiSelectIdField,
  SelectIdField,
  RadioButtonField,
  PhoneField,
  TextareaField,
  ParagraphField,
  ToggleButtonField,
} from '~fields';

const radioButtonAlignmentWidth = '170px';

const SnackForm = ({
  rooms,
  setExternalValidations,
  formik: { values, setFieldValue },
}) => {
  const {
    room,
    specialDiet,
    drink,
    specialDietPerson2,
    drinkPerson2,
    person2,
  } = values;

  const roomOptions = rooms.map(room => ({
    label: room.clinicalName,
    value: room.id,
  }));

  let locationOptions = [];
  if (room) {
    const selectedRoom = rooms.find(r => r.id === room);
    if (selectedRoom?.bedPlaces.length > 0) {
      locationOptions = selectedRoom?.bedPlaces.map(location => ({
        label: location.clinicalName,
        value: location.id,
      }));
    }
  }

  const handleRoomChange = room => {
    setFieldValue('location', null);
    const selectedRoom = rooms.find(r => r.id === room);
    const requireRoom = selectedRoom?.bedPlaces.length > 0;
    if (requireRoom) {
      setExternalValidations([
        {
          name: 'location',
          getError: value => (value ? undefined : 'Vaadittu'),
        },
      ]);
    } else {
      setExternalValidations([]);
    }
  };

  return (
    <Wrapper>
      <ParagraphField name="infoParagraph" />

      <LocationWrapper>
        <SelectIdField
          name="room"
          options={roomOptions}
          onChange={handleRoomChange}
          fallbackPlaceholder="Valitse..."
          required
        />
        <SelectIdField
          name="location"
          options={locationOptions}
          fallbackPlaceholder="Valitse..."
          disabled={!room || !locationOptions.length}
          required={!room || locationOptions.length}
        />
      </LocationWrapper>

      <Divider />

      <RadioButtonField
        name="specialDiet"
        flat
        firstElementMinWidth={radioButtonAlignmentWidth}
      />

      {specialDiet === 'YES' && (
        <MultiSelectIdField
          name="specialDietType"
          maxCharacterCount={40}
          required
        />
      )}

      <RadioButtonField
        name="warmDish"
        flat
        firstElementMinWidth={radioButtonAlignmentWidth}
      />

      <MultiSelectIdField name="sideDish" maxCharacterCount={40} />

      <DrinkWrapper>
        <MultiSelectIdField name="drink" />
        <MultiSelectIdField
          name="coffeeWith"
          disabled={
            !drink || !(drink.includes('Kahvi') || drink.includes('Tee'))
          }
        />
      </DrinkWrapper>

      <RadioButtonField
        name="feedingCup"
        flat
        firstElementMinWidth={radioButtonAlignmentWidth}
      />

      <Divider />

      <ToggleButtonField name="person2" />

      {person2 === 'YES' && (
        <Wrapper>
          <RadioButtonField
            name="specialDietPerson2"
            flat
            firstElementMinWidth={radioButtonAlignmentWidth}
          />
          {specialDietPerson2 === 'YES' && (
            <MultiSelectIdField
              name="specialDietTypePerson2"
              maxCharacterCount={40}
              required
            />
          )}
          <RadioButtonField
            name="warmDishPerson2"
            flat
            firstElementMinWidth={radioButtonAlignmentWidth}
          />
          <MultiSelectIdField name="sideDishPerson2" maxCharacterCount={40} />
          <DrinkWrapper>
            <MultiSelectIdField name="drinkPerson2" />
            <MultiSelectIdField
              name="coffeeWithPerson2"
              disabled={
                !drinkPerson2 ||
                !(
                  drinkPerson2.includes('Kahvi') || drinkPerson2.includes('Tee')
                )
              }
            />
          </DrinkWrapper>
        </Wrapper>
      )}

      <TextareaField name="additionalInfo" maxLength={300} />
      <PhoneField
        name="contactPhone"
        instruction="Täytä numero, jos haluat että sinuun otetaan yhteyttä"
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Divider = styled.hr`
  width: 100%;
  border-color: #ccc;
`;

const LocationWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  & > div {
    flex-basis: 100%;
  }
`;

const DrinkWrapper = styled(LocationWrapper)``;

export default SnackForm;
